export default function RagSection() {
  return (
    <section className="qs" id="s4">
      <div className="wrap">
        <div className="qhd pd-rv">
          <div>
            <span className="ey">
              <b>04</b>
              RAG 챗봇
            </span>
            <small>사내 지식에서 찾고, 출처와 함께 답변</small>
            <h2>
              지식베이스 검색과
              {' '}
              <em>답변 생성</em>
            </h2>
          </div>
        </div>
        <div className="qrag">
          <div className="qchat pd-rv">
            <div className="win">
              <div className="wh">
                <span className="ico">
                  <svg className="i">
                    <use href="#msg" />
                  </svg>
                </span>
                <div>
                  사내 규정 안내
                  <small>사용자 포탈 · 챗봇</small>
                </div>
                <span className="bdg g">
                  <span className="dt" style={{ background: "var(--grn)" }} />
                  배포됨
                </span>
              </div>
              <div className="wb">
                <div className="q">휴가 신청 절차를 알려주세요.</div>
                <div className="sp">
                  <span>
                    <i>
                      <svg className="i">
                        <use href="#search" />
                      </svg>
                    </i>
                    관련 지식 검색
                  </span>
                  <span>
                    <i>
                      <svg className="i">
                        <use href="#layers" />
                      </svg>
                    </i>
                    답변 근거 구성
                  </span>
                  <span>
                    <i>
                      <svg className="i">
                        <use href="#spark" />
                      </svg>
                    </i>
                    AI 답변 생성
                  </span>
                </div>
                <div className="an">
                  <mark>사내 규정에서 필요한 내용</mark>
                  을 찾아 안내합니다.
                  <sup>1</sup>
                  <ol className="qans">
                    <li>그룹웨어에서 근태 신청 메뉴를 선택합니다.</li>
                    <li>휴가 종류와 기간, 사유를 입력합니다.</li>
                    <li>팀장 승인 후 휴가가 확정됩니다.</li>
                  </ol>
                  <div className="srcs">
                    <span className="srcc">
                      <svg className="i">
                        <use href="#doc" />
                      </svg>
                      출처 · 사내 업무 매뉴얼
                    </span>
                  </div>
                </div>
              </div>
              <div className="wi">
                <span>무엇을 물어볼까요?</span>
                <i>
                  <svg className="i">
                    <use href="#up" />
                  </svg>
                </i>
              </div>
            </div>
            <div className="ui doc3 hl" style={{ position: "absolute" }}>
              <div className="doc">
                <span className="fi">PDF</span>
                <div>
                  <b>사내 업무 매뉴얼</b>
                  <span>관련 내용 보기</span>
                </div>
              </div>
            </div>
          </div>
          <div className="qside">
            <div className="qcd pd-rv d1 qsw">
              <div className="il p">
                <div className="mk qv" data-v="1" style={{ left: "24px", right: "24px" }}>
                  <div className="hd">
                    참고 문서
                    <span className="bdg">출처 3건</span>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "#E5484D", fontSize: "8px", fontWeight: "800" }}>
                      PDF
                    </span>
                    사내 업무 매뉴얼.pdf
                    <em>p.12</em>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "#2563EB" }}>
                      <svg className="i">
                        <use href="#globe" />
                      </svg>
                    </span>
                    인사 규정 안내 페이지
                    <span className="btnm o">링크</span>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "#E5484D", fontSize: "8px", fontWeight: "800" }}>
                      PDF
                    </span>
                    직무전결규정.pdf
                    <em>p.4</em>
                  </div>
                </div>
                <div className="mk qv" data-v="2" style={{ left: "24px", right: "24px" }}>
                  <div className="hd">
                    추천 질문
                    <span className="btnm o" style={{ gap: "4px" }}>
                      <svg className="i" style={{ width: "12px", height: "12px" }}>
                        <use href="#plus" />
                      </svg>
                      질문 등록
                    </span>
                  </div>
                  <div className="qqs">
                    <span className="on">휴가 신청 절차</span>
                    <span>출장비 정산 기준</span>
                    <span>보안 규정 안내</span>
                    <span>복리후생 제도</span>
                  </div>
                  <div className="qqa">
                    <span className="qb">휴가 신청 절차를 알려주세요.</span>
                    <span className="qg">
                      <svg className="i">
                        <use href="#search" />
                      </svg>
                      관련 지식 검색 중
                    </span>
                  </div>
                </div>
                <div className="mk qv" data-v="3" style={{ left: "24px", right: "24px" }}>
                  <div className="hd">
                    이전 대화
                    <span className="bdg">3건 저장됨</span>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "var(--org)" }}>
                      <svg className="i">
                        <use href="#history" />
                      </svg>
                    </span>
                    휴가 신청 절차 문의
                    <em>오늘</em>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "var(--org)" }}>
                      <svg className="i">
                        <use href="#history" />
                      </svg>
                    </span>
                    출장비 정산 기준
                    <em>어제</em>
                  </div>
                  <div className="r">
                    <span className="mini-ic" style={{ background: "var(--org)" }}>
                      <svg className="i">
                        <use href="#history" />
                      </svg>
                    </span>
                    보안 서약서 제출 방법
                    <em>10.12</em>
                  </div>
                </div>
              </div>
              <h4>질문하고 답변을 확인하는 대화 화면</h4>
              <p>질문에 대한 답변을 실시간으로 확인합니다.</p>
              <div className="qrow">
                <div data-v="1">
                  <span className="ico" style={{ background: "var(--ac)" }}>
                    <svg className="i">
                      <use href="#doc" />
                    </svg>
                  </span>
                  참고 문서 파일명·출처 링크 확인
                </div>
                <div data-v="2">
                  <span className="ico" style={{ background: "var(--teal)" }}>
                    <svg className="i">
                      <use href="#msg" />
                    </svg>
                  </span>
                  사전 등록 질문으로 빠른 질문
                </div>
                <div data-v="3">
                  <span className="ico" style={{ background: "var(--org)" }}>
                    <svg className="i">
                      <use href="#history" />
                    </svg>
                  </span>
                  이전 대화 내용 저장·불러오기
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="qsub pd-rv">지식 검색 및 AI 답변 생성 과정(RAG)</div>
        <div className="qflow3 pd-rv">
          <div className="qst">
            <div className="tp">
              <span className="ico" style={{ background: "var(--blu)" }}>
                <svg className="i">
                  <use href="#search" />
                </svg>
              </span>
              <b>01</b>
            </div>
            <h4>관련 지식 검색</h4>
            <p>연결된 지식베이스에서 질문과 관련된 내용을 찾습니다.</p>
          </div>
          <svg className="i">
            <use href="#arr" />
          </svg>
          <div className="qst">
            <div className="tp">
              <span className="ico" style={{ background: "var(--teal)" }}>
                <svg className="i">
                  <use href="#layers" />
                </svg>
              </span>
              <b>02</b>
            </div>
            <h4>답변 근거 구성</h4>
            <p>검색한 내용에서 중복을 제거하고 답변에 참고할 자료를 정리합니다.</p>
          </div>
          <svg className="i">
            <use href="#arr" />
          </svg>
          <div className="qst">
            <div className="tp">
              <span className="ico" style={{ background: "var(--pnk)" }}>
                <svg className="i">
                  <use href="#spark" />
                </svg>
              </span>
              <b>03</b>
            </div>
            <h4>AI 답변 생성</h4>
            <p>AI가 검색한 자료를 참고해 질문에 대한 답변을 만듭니다.</p>
          </div>
        </div>
        <div className="qsub pd-rv">AI 모델 및 제공자</div>
        <div className="qprov pd-rv">
          <div className="r h">
            <span>제공 방식</span>
            <span>지원 모델 · 연결 범위</span>
          </div>
          <div className="r">
            <div className="nm">
              <i>
                <img src="/site/logos/aws.svg" alt="" />
              </i>
              Amazon Bedrock
            </div>
            <div className="ch">
              <span>Nova Lite</span>
              <span>Nova Pro</span>
              <span>Nova 2 Lite</span>
              <span>Nova 2 Pro</span>
            </div>
          </div>
          <div className="r">
            <div className="nm">
              <i>
                <img src="/site/logos/aws.svg" alt="" />
              </i>
              Amazon Bedrock
            </div>
            <div className="ch">
              <span>Claude Haiku 4.5</span>
              <span>Claude Sonnet 4</span>
            </div>
          </div>
          <div className="r">
            <div className="nm">
              <i>
                <img src="/site/logos/anthropic.svg" alt="" />
              </i>
              Anthropic API
            </div>
            <div className="ch">
              <span>Claude Haiku 4.5</span>
              <span>Sonnet 4</span>
              <span>Sonnet 4.5</span>
              <span>Opus 4.5</span>
            </div>
          </div>
          <div className="r">
            <div className="nm">
              <i>
                <img src="/site/logos/openai.svg" alt="" />
              </i>
              OpenAI API
            </div>
            <div className="ch">
              <span>GPT-4</span>
              <span>GPT-3.5</span>
              <span className="n">제공자 관리</span>
            </div>
          </div>
          <div className="r">
            <div className="nm">
              <i>
                <img src="/site/logos/gemini.svg" alt="" />
              </i>
              Google AI API
            </div>
            <div className="ch">
              <span>Gemini</span>
              <span className="n">제공자 관리</span>
            </div>
          </div>
        </div>
        <div className="pnote pd-rv">
          <span>연결된 지식베이스에서 질문과 관련된 내용을 찾아 답변합니다.</span>
          <span>답변에 참고한 문서의 출처도 함께 확인할 수 있습니다.</span>
        </div>
      </div>
    </section>
  );
}
